// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_ci","advertCardNum":"c-a_cj","advertCardUp":"c-a_ck"};